import { constants } from './constants';

const {
  TOOLBAR_ROW_TYPE,
  DEFAULT_TOOLBAR_NAME,
} = constants;

/**
 * Helper function to generate the projection-grid row config for a toolbar
 * @param {string} name - The name of the toolbar
 * @returns {RowConfig} - The projection-grid row config for the given toolbar
 */
function toolbarRow(name) {
  return { type: TOOLBAR_ROW_TYPE, name };
}

/**
 * Helper function to generate the projection-grid headRows config for the
 * single toolbar cases
 * @returns {RowsCofnig} - The projection-grid headRows config
 */
function singleToolbarHeadRows() {
  return [
    toolbarRow(DEFAULT_TOOLBAR_NAME),
    'column-header-rows',
  ];
}


/**
 * Helper function to generate the toolbar plugin config for the single
 * toolbar cases
 * @param {Object} options - The options to construct the toolbar
 * @returns {Object} - The toolbar plugin config
 */
function singleToolbar(options) {
  return { [DEFAULT_TOOLBAR_NAME]: options };
}

export const helpers = {
  toolbarRow,
  singleToolbarHeadRows,
  singleToolbar,
};
